import React from 'react';
import { Navigate } from 'react-router-dom';
import { getTemplateUrl } from '../../../../services/StorageService';
import { useDistribution } from '../../../../hooks';
import { Recipients } from '../Recipients';
import { Container, PrimaryRow } from './styles';

const Resume: React.FC = () => {
    const { template, exhibitor } = useDistribution();

    if (!template || !exhibitor)
        return <Navigate to="/home" replace />;

    return (
        <Container>
            <span>Confira a distribuição que será realizada:</span>
            <img src={getTemplateUrl(template.uuid, template.backgroundEmailFile)} alt={template.name} />
            <PrimaryRow>
                <strong>TEMPLATE:</strong>
                <small>{template.name}</small>
            </PrimaryRow>
            <Recipients resume />
        </Container>
    );
};

export { Resume };
